import NoteStore from '../stores/NoteStore.js';
import SessionStore from '../stores/SessionStore.js'

function select(note) {
  if (NoteStore.isCurrentNote(note)) {
    SessionStore.recordSuccess();
  } else {
    SessionStore.recordFailure(note);
  }
}

function className(note) {
  if (SessionStore.isFailure(note)) {
    return 'selection wrong';
  }
  return 'selection';
}

function NoteButton(props) {
  const {note} = props;

  return (
    <button
      className={className(note)}
      onClick={() => {
        select(note);
      }}>
      {note}
    </button>
  );
}


export default NoteButton;
